export default {
  FETCH_LOGIN: "FETCH_LOGIN",
  FETCH_LOGIN_SUCCESS: "FETCH_LOGIN_SUCCESS",
  FETCH_LOGIN_FAILURE: "FETCH_LOGIN_FAILURE",
  LOGOUT: "LOGOUT",
  REHYDRATE_AUTH_USER: "REHYDRATE_AUTH_USER",
  FETCH_DEVICES: "FETCH_DEVICES",
  FETCH_DEVICES_SUCCESS: "FETCH_DEVICES_SUCCESS",
  FETCH_DEVICE_DATA: "FETCH_DEVICES_DATA",
  FETCH_DEVICE_DATA_SUCCESS: "FETCH_DEVICE_DATA_SUCCESS",
  CLEAR_ERROR_TOAST: "CLEAR_ERROR_TOAST",
  SET_QUOTA: "SET_QUOTA",
  APPLY_QUOTA: "APPLY_QUOTA",
  SET_SELECTED_DEVICES: "SET_SELECTED_DEVICES",

  SET_DEVICES: "SET_DEVICES",
  CLEAR_DEVICES_REDUCER: "CLEAR_DEVICES_REDUCER",
  FETCH_DEVICES_DATA_MODELS: "FETCH_DEVICES_DATA_MODELS",
  SET_LANGUAGE: "SET_LANGUAGE",

  ALERT: {
    FIRE_ERROR_ALERT: "ALERT_FIRE_ERROR_ALERT",
    END_ERROR_ALERT: "ALERT_END_ERROR_ALERT",
  },
  DATE_SELECTOR: {
    CHANGE_START_DATE: "DATE_SELECTOR_CHANGE_START_DATE",
  },
  ORGANIZATIONS: {
    FETCH_ALL_ORGANIZATIONS_LIST_START: "ORGANIZATIONS__FETCH_ALL_ORGANIZATIONS_LIST_START",
    FETCH_ALL_ORGANIZATIONS_LIST_SUCCESS: "ORGANIZATIONS__FETCH_ALL_ORGANIZATIONS_LIST_SUCCESS",
    FETCH_ORGANIZATION_DEVICES_LIST: "ORGANIZATIONS__FETCH_ORGANIZATION_DEVICES_LIST",
    FETCH_ORGANIZATION_DEVICES_LIST_FAILURE: "ORGANIZATIONS__FETCH_ORGANIZATION_DEVICES_LIST_FAILURE",
    FETCH_ALL_ORGANIZATIONS_LIST_FAILURE: "ORGANIZATIONS__FETCH_ALL_ORGANIZATIONS_LIST_FAILURE",
    FETCH_ORGANIZATION_ABILITY_START: "ORGANIZATIONS__FETCH_ORGANIZATION_ABILITY_START",
    FETCH_ORGANIZATION_ABILITY_SUCCESS: "ORGANIZATIONS__FETCH_ORGANIZATION_ABILITY_SUCCESS",
    FETCH_ORGANIZATION_ABILITY_FAILURE: "ORGANIZATIONS__FETCH_ORGANIZATION_ABILITY_FAILURE",

    FETCH_ORGANIZATION_INFO: "ORGANIZATIONS__FETCH_ORGANIZATION_INFO",
    FETCH_ORGANIZATION_INFO_FAILURE: "ORGANIZATIONS__FETCH_ORGANIZATION_INFO_FAILURE",
  },
  USERS: {
    FETCH_USER_ABILITY_START: "USERS__FETCH_USER_ABILITY_START",
    FETCH_USER_ABILITY_SUCCESS: "USERS__FETCH_USER_ABILITY_SUCCESS",
    FETCH_USER_ABILITY_FAILURE: "USERS__FETCH_USER_ABILITY_FAILURE",

    FETCH_ALL_USER_START: "USERS__FETCH_ALL_USER_START",
    FETCH_ALL_USER_SUCCESS: "USERS__FETCH_ALL_USER_SUCCESS",
    FETCH_ALL_USER_FAILURE: "USERS__FETCH_ALL_USER_FAILURE",
  },
  DEVICES: {
    PREPEND_TO_SELECTED_DEVICES: "DEVICES__PREPEND_TO_SELECTED_DEVICES",
    SET_DEVICES_LIFECYCLES: "DEVICES__SET_DEVICES_LIFECYCLES",

    SET_DEVICES_LIST: "DEVICES_SET_DEVICES_LIST",
    SET_DEVICES_LIST_SUCCESS: "DEVICES_SET_DEVICES_LIST_SUCCESS",

    CLEAR_FILTERS_START: "DEVICES_CLEAR_FILTERS_START",
    SET_DEFAULT_FILTERS_LISTS: "DEVICES__SET_DEFAULT_FILTERS_LISTS",
    CLEAR_FILTERS_SUCCESS: "DEVICES_CLEAR_FILTERS_SUCCESS",
    SET_DEVICETYPE_CATEGORIES: "SET_DEVICETYPE_CATEGORIES",
    SET_SELECTED_DEVICETYPE_CATEGORIES: "SET_SELECTED_DEVICETYPE_CATEGORIES",

    SELECTED_DEVICE_INFO: "DEVICES_SELECTED_DEVICE_INFO",
    NO_SELECTED_DEVICE_INFO: "DEVICES_NO_SELECTED_DEVICE_INFO",
    UPDATE_SELECTED_DEVICE_INFO: "DEVICES_UPDATE_SELECTED_DEVICE_INFO",
    SELECTED_DEVICE_SERVICE: "DEVICES_SELECTED_DEVICE_SERVICE",
    SELECTED_DEVICE_LIVE_DATA: "DEVICES_SELECTED_DEVICE_LIVE_DATA",
    SELECTED_DEVICE_ALARMS: "DEVICES_SELECTED_DEVICE_ALARMS",
    SELECTED_DEVICE_DELETED: "DEVICES_SELECTED_DEVICE_DELETED",

    /**
     * ELEVATION
     */
    CALCULATE_ELEVATION_START: "DEVICES__CALCULATE_ELEVATION_START",
    CALCULATE_ELEVATION_SUCCESS: "DEVICES__CALCULATE_ELEVATION_SUCCESS",
    CALCULATE_ELEVATION_FAILURE: "DEVICES__CALCULATE_ELEVATION_FAILURE",

    FETCH_ALL_DEVICES_LIST_START: "DEVICES__FETCH_ALL_DEVICES_LIST_START",
    FETCH_ALL_DEVICES_LIST_SUCCESS: "DEVICES__FETCH_ALL_DEVICES_LIST_SUCCESS",
    FETCH_ALL_DEVICES_LIST_FAILURE: "DEVICES__FETCH_ALL_DEVICES_LIST_FAILURE",

    FETCH_ALL_DEVICES_WITH_NO_PAGINATION: "FETCH_ALL_DEVICES_WITH_NO_PAGINATION",

    FETCH_SELECTED_DEVICES_LIST_START: "DEVICES__FETCH_SELECTED_DEVICES_LIST_START",
    FETCH_SELECTED_DEVICES_LIST_SUCCESS: "DEVICES__FETCH_SELECTED_DEVICES_LIST_SUCCESS",
    FETCH_SELECTED_DEVICES_LIST_FAILURE: "DEVICES__FETCH_SELECTED_DEVICES_LIST_FAILURE",
    SET_NO_DEVICE_SELECTED: "DEVICES__SET_NO_DEVICE_SELECTED",

    SET_DEVICE_OWNERS: "DEVICES__SET_DEVICE_OWNERS",

    FETCH_ALL_ORGANIZATIONS_LIST_START: "DEVICES__FETCH_ALL_ORGANIZATIONS_LIST_START",
    FETCH_ALL_ORGANIZATIONS_LIST_SUCCESS: "DEVICES__FETCH_ALL_ORGANIZATIONS_LIST_SUCCESS",
    FETCH_ALL_ORGANIZATIONS_LIST_FAILURE: "DEVICES__FETCH_ALL_ORGANIZATIONS_LIST_FAILURE",

    SET_SELECTED_TYPES_LIST_START: "DEVICES__SET_SELECTED_TYPES_LIST_START",
    SET_SELECTED_TYPES_LIST_FAILURE: "DEVICES__SET_SELECTED_TYPES_LIST_FAILURE",
    SET_SELECTED_TYPES_LIST_SUCCESS: "DEVICES__SET_SELECTED_TYPES_LIST_SUCCESS",

    FETCH_ALL_TYPES_LIST_START: "DEVICES__FETCH_ALL_TYPES_LIST_START",
    FETCH_ALL_TYPES_LIST_SUCCESS: "DEVICES__FETCH_ALL_TYPES_LIST_SUCCESS",
    FETCH_ALL_TYPES_LIST_FAILURE: "DEVICES__FETCH_ALL_TYPES_LIST_FAILURE",

    SET_SELECTED_TYPES_LIST: "DEVICES__SET_SELECTED_TYPES_LIST",

    SET_SELECTED_MODELS_LIST_START: "DEVICES__SET_SELECTED_MODELS_LIST_START",
    SET_SELECTED_MODELS_LIST_FAILURE: "DEVICES__SET_SELECTED_MODELS_LIST_FAILURE",
    SET_SELECTED_MODELS_LIST_SUCCESS: "DEVICES__SET_SELECTED_MODELS_LIST_SUCCESS",
    FETCH_ALL_MODELS_LIST_START: "DEVICES__FETCH_ALL_MODELS_LIST_START",
    FETCH_ALL_MODELS_LIST_SUCCESS: "DEVICES__FETCH_ALL_MODELS_LIST_SUCCESS",
    FETCH_ALL_MODELS_LIST_FAILURE: "DEVICES__FETCH_ALL_MODELS_LIST_FAILURE",

    SET_SELECTED_MODELS_LIST: "DEVICES__SET_SELECTED_MODELS_LIST",
    FILTERS_START: "DEVICES__FILTERS_START",

    SET_DEVICE_CONTRACTS_LIST_START: "DEVICES__SET_DEVICE_CONTRACTS_LIST_START",
    SET_DEVICE_CONTRACTS_LIST: "DEVICES__SET_DEVICE_CONTRACTS_LIST",
    SET_DEVICE_CONTRACTS_LIST_FAILURE: "DEVICES__SET_DEVICE_CONTRACTS_LIST_FAILURE",

    REMOVE_DEVICE_FROM_CONTRACT_START: "DEVICES__REMOVE_DEVICE_FROM_CONTRACT_START",
    REMOVE_DEVICE_FROM_CONTRACT: "DEVICES__REMOVE_DEVICE_FROM_CONTRACT",
    REMOVE_DEVICE_FROM_CONTRACT_FALURE: "DEVICES__REMOVE_DEVICE_FROM_CONTRACT_FALURE",

    FETCHING_DEVICE_IMAGES_START: "DEVICES__FETCHING_DEVICE_IMAGES_START",
    FETCHING_DEVICE_IMAGES: "DEVICES__FETCHING_DEVICE_IMAGES",
    FETCHING_DEVICE_IMAGES_FALURE: "DEVICES__FETCHING_DEVICE_IMAGES_FALURE",
    UPLOAD_ALL_PICTURES_START: "DEVICES__UPLOAD_ALL_PICTURES_START",
    UPLOAD_ALL_PICTURES: "DEVICES__UPLOAD_ALL_PICTURES",
    UPLOAD_ALL_PICTURES_FAILURE: "DEVICES__UPLOAD_ALL_PICTURES_FAILURE",
    UI: {
      SWITCH_ELEVATION_TOGGLE: "DEVICES__SWITCH_ELEVATION_TOGGLE",
      // SWITCH_CUSTOM_RANGE: "DEVICES__UI__SWITCH_CUSTOM_RANGE"
    },
    RESET_CALCULATION_START: "RESET_CALCULATION_START",
    RESET_CALCULATION_SUCCESS: "RESET_CALCULATION_SUCCESS",
    REMOVE_DEVICE_IMAGE: "REMOVE_DEVICE_IMAGE",
    REMOVE_DEVICE_IMAGE_FAILURE: "REMOVE_DEVICE_IMAGE_FAILURE",
    SET_SELECTED_DEVICE_INFO: "DEVICES__SET_SELECTED_DEVICE_INFO",
  },

  TRENDS: {
    CLEAR_GROUPS_LIST: "TRENDS__CLEAR_GROUPS_LIST",

    GET_ALL_ORGNANIZATION: "TRENDS__GET_ALL_ORGNANIZATION",
    GET_ALL_GROUPS: "TRENDS__GET_ALL_GROUPS",
    START_FETCHING_GROUPS: "TRENDS__START_FETCHING_GROUPS",
    GET_ORGANIZATION_GROUPS: "TRENDS__GET_ORGANIZATION_GROUPS",
    SET_SELECTED_ORGNANIZATION: "TRENDS__SET_SELECTED_ORGNANIZATION",
    SELECTED_ORGANIZATION_HAS_NO_GROUPS: "TRENDS__SELECTED_ORGANIZATION_HAS_NO_GROUPS",
    SET_CURRENT_ACTIVE_MODE: "TRENDS__SET_CURRENT_ACTIVE_MODE",

    SET_REF_LIST: "SET_CONSTS__ANALYTICS__REF_LIST",
    SET_PERIOD_LIST: "SET_CONSTS__ANALYTICS__PERIOD_LIST",
    SET_SELECTED_CURRENT_ACTIVE_MODE: "SET_CONSTS__ANALYTICS__SELECTED_CURRENT_ACTIVE_MODE",
    SELECTED_GROUP: "TRENDS__SELECTED_GROUP",
    SELECTED_REF: "TRENDS__SELECTED_REF",
    SELECTED_PERIOD: "TRENDS__SELECTED_PERIOD",
    SELECTED_DATE: "TRENDS__SELECTED_DATE",

    UPDATE_DEVICES_WITH_DETAILS_LIST: "TRENDS__UPDATE_DEVICES_WITH_DETAILS_LIST",
    UPDATE_ALL_TRENDS_DEVICES_DATA: "TRENDS__UPDATE_ALL_TRENDS_DEVICES_DATA",
    CHANGE_DEVICE_DATA_IS_EXPANDED: "TRENDS__CHANGE_DEVICE_DATA_IS_EXPANDED",
    UPDATE_ONE_TRENDS_DEVICES_DATA: "TRENDS__UPDATE_ONE_TRENDS_DEVICES_DATA",
    REMOVE_FROM_TRENDS_DEVICES: "TRENDS__REMOVE_FROM_TRENDS_DEVICES",
    SET_ALL_TRENDS_DEVICES_TO_FETCH: "TRENDS__SET_ALL_TRENDS_DEVICES_TO_FETCH",
  },
  SERVICE_SCHEDULES: {
    GET_ORGANIZATION_GROUPS: "SERVICE_SCHEDULES__GET_ORGANIZATION_GROUPS",
    UPDATE_DEVICE_THRESHOLD: "SERVICE_SCHEDULES_UPDATE_DEVICE_THRESHOLD",
    UPDATE_ONE_SERVICE_SCHEDULES_DEVICES_DATA: "SERVICE_SCHEDULES_UPDATE_ONE_SERVICE_SCHEDULES_DEVICES_DATA",
    RESET_SERVICE_SCHEDULES: "SERVICE_SCHEDULES_RESET_SERVICE_SCHEDULES",
  },
  COMPARE: {
    SET_SELECTED_DEVICES_LIST: "COMPARE__SET_SELECTED_DEVICES_LIST",
    SET_SELECTED_DEVICES_LIST_DATA: "COMPARE__SET_SELECTED_DEVICES_LIST_DATA",
    FETCH_SELECTED_DEVICES_LIST_DATA: "COMPARE__FETCH_SELECTED_DEVICES_LIST_DATA",
  },
  CONSTS: {
    ANALYTICS: {
      REF_LOAD: "CONSTS__ANALYTICS__REF_LOAD",
      PERIOD_LOAD: "CONSTS__ANALYTICS__PERIOD_LOAD",
    },
  },
  INTEGRATION: {
    CLEAR_INTEGRATIONS: "INTEGRATION__CLEAR_INTEGRATIONS",
    TOGGLE_COMPACT_VIEW: "INTEGRATION__TOGGLE_COMPACT_VIEW",
    SET_IS_COMPACT_VIEW: "INTEGRATION__SET_IS_COMPACT_VIEW",
    SET_SELECTED_DEVICES: "INTEGRATION__SET_SELECTED_DEVICES",
    SET_NO_SELECTED_DEVICES: "INTEGRATION__SET_NO_SELECTED_DEVICES",
    SET_SELECTED_SYSTEMS: "INTEGRATION__SET_SELECTED_SYSTEMS",
    SET_SELECTED_CLIENT: "INTEGRATION__SET_SELECTED_CLIENT",
    SET_SELECTED_SYSTEM_CLIENTS: "INTEGRATION__SET_SELECTED_SYSTEM_CLIENTS",
    SET_SELECTED_SYSTEM_CLIENTS_FAILURE: "INTEGRATION__SET_SELECTED_SYSTEM_CLIENTS_FAILURE",
    SET_INTEGRATIONS_CLIENT_INTEGRATED_DEVICES: "INTEGRATION__SET_INTEGRATIONS_CLIENT_INTEGRATED_DEVICES",
    SET_INTEGRATIONS_CLIENT_INTEGRATED_DEVICES_FAILURE: "INTEGRATION__SET_INTEGRATIONS_CLIENT_INTEGRATED_DEVICES_FAILURE",
    SET_INTEGRATIONS_SYSTEMS: "INTEGRATION__SET_INTEGRATIONS_SYSTEMS",

    INTEGRATE_NEW_DEVICES_SUCCESS: "INTEGRATION__INTEGRATE_NEW_DEVICES_SUCCESS",
    INTEGRATE_NEW_DEVICES_FAILURE: "INTEGRATION__INTEGRATE_NEW_DEVICES_FAILURE",
    INTEGRATE_NEW_DEVICES_STARTED: "INTEGRATION__INTEGRATE_NEW_DEVICES_STARTED",
    DELETE_INTEGRATED_DEVICE_SUCCESS: "INTEGRATION__DELETE_INTEGRATED_DEVICE_SUCCESS",
    DELETE_INTEGRATED_DEVICE_FAILURE: "INTEGRATION__DELETE_INTEGRATED_DEVICE_FAILURE",
    SET_INTEGRATIONS_SYSTEMS_FAILURE: "INTEGRATION__SET_INTEGRATIONS_SYSTEMS_FAILURE",
  },
  CONTRACTS: {
    FETCH_ORGANIZATIONS_ALL_CONTRACTS_LIST_START: "CONTRACTS__FETCH_ORGANIZATIONS_ALL_CONTRACTS_LIST_START",
    FETCH_ORGANIZATIONS_ALL_CONTRACTS_LIST_SUCCESS: "CONTRACTS__FETCH_ORGANIZATIONS_ALL_CONTRACTS_LIST_SUCCESS",
    FETCH_ORGANIZATIONS_ALL_CONTRACTS_LIST_FAILURE: "CONTRACTS__FETCH_ORGANIZATIONS_ALL_CONTRACTS_LIST_FAILURE",
    FETCH_SELECTED_CONTRACT_INFO_START: "CONTRACTS__FETCH_SELECTED_CONTRACT_INFO_START",
    SET_SELECTED_CONTRACTS: "CONTRACTS__SET_SELECTED_CONTRACTS",
    FETCH_SELECTED_CONTRACT_DEVICES_START: "CONTRACTS__FETCH_SELECTED_CONTRACT_DEVICES_START",
    SET_SELECTED_CONTRACT_DEVICES: "CONTRACTS__SET_SELECTED_CONTRACT_DEVICES",
    FETCH_SELECTED_CONTRACT_DEVICES_FAILURE: "CONTRACTS__FETCH_SELECTED_CONTRACT_DEVICES_FAILURE",
    TOGGLE_IS_EDIT_CONTRACT_MODE: "CONTRACTS__TOGGLE_IS_EDIT_CONTRACT_MODE",
    CLEAR_SELECTED_CONTRACT: "CONTRACTS__CLEAR_SELECTED_CONTRACT",
    REMOVE_DEVICE_FROM_CONTRACT_START: "CONTRACTS__REMOVE_DEVICE_FROM_CONTRACT_START",
    REMOVE_DEVICE_FROM_CONTRACT: "CONTRACTS__REMOVE_DEVICE_FROM_CONTRACT",
    REMOVE_DEVICE_FROM_CONTRACT_FALURE: "CONTRACTS__REMOVE_DEVICE_FROM_CONTRACT_FALURE",
    DELETE_CONTRACT_START: "CONTRACTS__DELETE_CONTRACT_START",
    DELETE_CONTRACT: "CONTRACTS__DELETE_CONTRACT",
    DELETE_CONTRACT_FALURE: "CONTRACTS__DELETE_CONTRACT_FALURE",
    FETCH_CONTRACT_PACKAGES: "CONTRACTS__FETCH_CONTRACT_PACKAGES",
    ADD_CONTRACT_START: "CONTRACTS__ADD_CONTRACT_START",
    ADD_CONTRACT: "CONTRACTS__ADD_CONTRACT",
    ADD_CONTRACT_FALURE: "CONTRACTS__ADD_CONTRACT_FALURE",

    ASSIGN_DEVICES_TO_CONTRACT_START: "CONTRACTS__ASSIGN_DEVICES_TO_CONTRACT_START",
    ASSIGN_DEVICES_TO_CONTRACT: "CONTRACTS__ASSIGN_DEVICES_TO_CONTRACT",
    ASSIGN_DEVICES_TO_CONTRACT_FALURE: "CONTRACTS__ASSIGN_DEVICES_TO_CONTRACT_FALURE",
    SUBMIT_EDIT_CONTRACT_START: "CONTRACT__SUBMIT_EDIT_CONTRACT_START",
    SUBMIT_EDIT_CONTRACT: "CONTRACT__SUBMIT_EDIT_CONTRACT",
    SUBMIT_EDIT_CONTRACT_FALURE: "CONTRACT__SUBMIT_EDIT_CONTRACT_FALURE",
    FETCH_CONTRACTS_LOGS_LIST_START: "CONTRACTS__FETCH_CONTRACTS_LOGS_LIST_START",
    FETCH_CONTRACTS_LOGS_LIST_SUCCESS: "CONTRACTS__FETCH_CONTRACTS_LOGS_LIST_SUCCESS",
    FETCH_CONTRACTS_LOGS_LIST_FAILURE: "CONTRACTS__FETCH_CONTRACTS_LOGS_LIST_FAILURE",
  },
  SERVICES: {
    SET_MAIN_VIEW: "SERVICES__SET_MAIN_VIEW",
    SET_VIEW_MODE: "SERVICES__SET_VIEW_MODE",
    FETCH_ALSERVICE_CENTERER_START: "SERVICES__FETCH_ALSERVICE_CENTERER_START",
    FETCH_ALL_SERVICE_CENTER_SUCCESS: "SERVICES__FETCH_ALL_SERVICE_CENTER_SUCCESS",
    FETCH_ALL_SERVICE_CENTER_FAILURE: "SERVICES__FETCH_ALL_SERVICE_CENTER_FAILURE",

    ADD_NEW_SUCCESS: "SERVICES__ADD_NEW_SUCCESS",
    ADD_NEW_FAILURE: "SERVICES__ADD_NEW_FAILURE",

    FETCH_SPECIFIC_SERVICE_CENTERER_START: "SERVICES__FETCH_SPECIFIC_SERVICE_CENTERER_START",
    FETCH_SPECIFIC_SERVICE_CENTER_SUCCESS: "SERVICES__FETCH_SPECIFIC_SERVICE_CENTER_SUCCESS",
    FETCH_SPECIFIC_SERVICE_CENTER_FAILURE: "SERVICES__FETCH_SPECIFIC_SERVICE_CENTER_FAILURE",

    FETCH_SERVICE_CENTER_TECHNICIANS_START: "SERVICES__FETCH_SERVICE_CENTER_TECHNICIANS_START",
    FETCH_SERVICE_CENTER_TECHNICIANS_SUCCESS: "SERVICES__FETCH_SERVICE_CENTER_TECHNICIANS_SUCCESS",
    FETCH_SERVICE_CENTER_TECHNICIANS_FAILURE: "SERVICES__FETCH_SERVICE_CENTER_TECHNICIANS_FAILURE",

    SET_SELECTED_TECHNICIAN: "SERVICES__SET_SELECTED_TECHNICIAN",

    REMOVE_TECHNICIAN_FROM_CENTER_START: "SERVICES__REMOVE_TECHNICIAN_FROM_CENTER_START",
    REMOVE_TECHNICIAN_FROM_CENTER: "SERVICES__REMOVE_TECHNICIAN_FROM_CENTER",
    REMOVE_TECHNICIAN_FROM_CENTER_FALURE: "SERVICES__REMOVE_TECHNICIAN_FROM_CENTER_FALURE",

    DEACTIVATE_TECHNICIAN_FROM_CENTER_START: "SERVICES__DEACTIVATE_TECHNICIAN_FROM_CENTER_START",
    DEACTIVATE_TECHNICIAN_FROM_CENTER: "SERVICES__DEACTIVATE_TECHNICIAN_FROM_CENTER",
    DEACTIVATE_TECHNICIAN_FROM_CENTER_FALURE: "SERVICES__DEACTIVATE_TECHNICIAN_FROM_CENTER_FALURE",

    UPDATE_SERVICE_CENTER_START: "SERVICES__UPDATE_SERVICE_CENTER_START",
    UPDATE_SERVICE_CENTER: "SERVICES__UPDATE_SERVICE_CENTER",
    UPDATE_SERVICE_CENTER_FALURE: "SERVICES__UPDATE_SERVICE_CENTER_FALURE",

    DELETE_SERVICE_CENTER_START: "SERVICES__DELETE_SERVICE_CENTER_START",
    DELETE_SERVICE_CENTER: "SERVICES__DELETE_SERVICE_CENTER",
    DELETE_SERVICE_CENTER_FALURE: "SERVICES__DELETE_SERVICE_CENTER_FALURE",

    CREATE_TECHNICIAN_START: "SERVICES__CREATE_TECHNICIAN_START",
    CREATE_TECHNICIAN: "SERVICES__CREATE_TECHNICIAN",
    CREATE_TECHNICIAN_FALURE: "SERVICES__CREATE_TECHNICIAN_FALURE",

    FETCH_ALL_TECHNICIANS_START: "SERVICES__FETCH_ALL_TECHNICIANS_START",
    FETCH_ALL_TECHNICIANS_SUCCESS: "SERVICES__FETCH_ALL_TECHNICIANS_SUCCESS",
    FETCH_ALL_TECHNICIANS_FAILURE: "SERVICES__FETCH_ALL_TECHNICIANS_FAILURE",

    FETCH_TECHNICIAN_DETAILS_START: "SERVICES__FETCH_TECHNICIAN_DETAILS_START",
    FETCH_TECHNICIAN_DETAILS: "SERVICES__FETCH_TECHNICIAN_DETAILS",
    FETCH_TECHNICIAN_DETAILS_FALURE: "SERVICES__FETCH_TECHNICIAN_DETAILS_FALURE",

    EDIT_TECHNICIAN_START: "SERVICES__EDIT_TECHNICIAN_START",
    EDIT_TECHNICIAN: "SERVICES__EDIT_TECHNICIAN",
    EDIT_TECHNICIAN_FALURE: "SERVICES__EDIT_TECHNICIAN_FALURE",
  },
  INSTALLATION: {
    CREATE_NEW_INSTALLATION_ORDER_START: "INSTALLATION__CREATE_NEW_INSTALLATION_ORDER_START",
    CREATE_NEW_INSTALLATION_ORDER: "INSTALLATION__CREATE_NEW_INSTALLATION_ORDER",
    CREATE_NEW_INSTALLATION_ORDER_FAILURE: "INSTALLATION__CREATE_NEW_INSTALLATION_ORDER_FAILURE",

    GET_ALL_INSTALLATION_ORDER_START: "INSTALLATION__GET_ALL_INSTALLATION_ORDER_START",
    GET_ALL_INSTALLATION_ORDER: "INSTALLATION__GET_ALL_INSTALLATION_ORDER",
    GET_ALL_INSTALLATION_ORDER_FAILURE: "INSTALLATION__GET_ALL_INSTALLATION_ORDER_FAILURE",

    GET_INSTALLATION_ORDER_DEATILS_START: "INSTALLATION__GET_INSTALLATION_ORDER_DEATILS_START",
    GET_INSTALLATION_ORDER_DEATILS: "INSTALLATION__GET_INSTALLATION_ORDER_DEATILS",
    GET_INSTALLATION_ORDER_DEATILS_FAILURE: "INSTALLATION__GET_INSTALLATION_ORDER_DEATILS_FAILURE",
    DELETE_INSTALLATION_ORDER: "INSTALLATION__DELETE_INSTALLATION_ORDER",
    DELETE_INSTALLATION_ORDER_FAILURE: "INSTALLATION__DELETE_INSTALLATION_ORDER_FAILURE",

    GET_INSTALLATION_ORDER_DEVICES_START: "INSTALLATION__GET_INSTALLATION_ORDER_DEVICES_START",
    GET_INSTALLATION_ORDER_DEVICES: "INSTALLATION__GET_INSTALLATION_ORDER_DEVICES",
    GET_INSTALLATION_ORDER_DEVICES_FAILURE: "INSTALLATION__GET_INSTALLATION_ORDER_DEVICES_FAILURE",

    UPDATE_ORDER_DEVICE_NOTE_START: "INSTALLATION__UPDATE_ORDER_DEVICE_NOTE_START",
    UPDATE_ORDER_DEVICE_NOTE: "INSTALLATION__UPDATE_ORDER_DEVICE_NOTE",
    UPDATE_ORDER_DEVICE_NOTE_FAILURE: "INSTALLATION__UPDATE_ORDER_DEVICE_NOTE_FAILURE",

    GET_DEVICE_INSTALLATION_ORDER_ATTACHMENTS_LIST_START: "INSTALLATION__GET_DEVICE_INSTALLATION_ORDER_ATTACHMENTS_LIST_START",
    GET_DEVICE_INSTALLATION_ORDER_ATTACHMENTS_LIST: "INSTALLATION__GET_DEVICE_INSTALLATION_ORDER_ATTACHMENTS_LIST",
    GET_DEVICE_INSTALLATION_ORDER_ATTACHMENTS_LIST_FAILURE:
      "INSTALLATION__GET_DEVICE_INSTALLATION_ORDER_ATTACHMENTS_LIST_FAILURE",

    UPDATE_INSTALLATION_ORDER_DEVICE_START: "INSTALLATION__UPDATE_INSTALLATION_ORDER_DEVICE_START",
    UPDATE_INSTALLATION_ORDER_DEVICE: "INSTALLATION__UPDATE_INSTALLATION_ORDER_DEVICE",
    UPDATE_INSTALLATION_ORDER_DEVICE_FAILURE: "INSTALLATION__UPDATE_INSTALLATION_ORDER_DEVICE_FAILURE",

    DELETE_INSTALLATION_ORDER_DEVICE: "INSTALLATION__DELETE_INSTALLATION_ORDER_DEVICE",
    DELETE_INSTALLATION_ORDER_DEVICE_FAILURE: "INSTALLATION__DELETE_INSTALLATION_ORDER_DEVICE_FAILURE",
    DELETE_INSTALLATION_ORDER_DEVICE_ATTACHMENT: "INSTALLATION__DELETE_INSTALLATION_ORDER_DEVICE_ATTACHMENT",
    DELETE_INSTALLATION_ORDER_DEVICE_ATTACHMENT_FAILURE: "INSTALLATION__DELETE_INSTALLATION_ORDER_DEVICE_ATTACHMENT_FAILURE",

    GET_ALL_INSTALLATION_ORDER_OWNER_START: "INSTALLATION__GET_ALL_INSTALLATION_ORDER_OWNER_START",
    GET_ALL_INSTALLATION_ORDER_OWNER: "INSTALLATION__GET_ALL_INSTALLATION_ORDER_OWNER",

    GET_ALL_INSTALLATION_ORDER_OWNER_FAILURE: "INSTALLATION__GET_ALL_INSTALLATION_ORDER_OWNER_FAILURE",
    GET_ALL_INSTALLATION_ORDER_TECHNICIANS_START: "INSTALLATION__GET_ALL_INSTALLATION_ORDER_TECHNICIANS_START",
    GET_ALL_INSTALLATION_ORDER_TECHNICIANS: "INSTALLATION__GET_ALL_INSTALLATION_ORDER_TECHNICIANS",

    GET_ALL_INSTALLATION_ORDER_TECHNICIANS_FAILURE: "INSTALLATION__GET_ALL_INSTALLATION_ORDER_TECHNICIANS_FAILURE",
    SET_SELECTED_DEVICE_TO_INSTALL_START: "INSTALLATION__SET_SELECTED_DEVICE_TO_INSTALL_START",
    SET_SELECTED_DEVICE_TO_INSTALL: "INSTALLATION__SET_SELECTED_DEVICE_TO_INSTALL",

    SET_WIZARD_ACTIVE_STEP: "INSTALLATION__SET_WIZARD_ACTIVE_STEP",

    SET_DEVICE_INSTALL_DATA: "INSTALLATION__SET_DEVICE_INSTALL_DATA",

    SUBMIT_INSTALL_DEVICE_START: "INSTALLATION__SUBMIT_INSTALL_DEVICE_START",
    SUBMIT_INSTALL_DEVICE: "INSTALLATION__SUBMIT_INSTALL_DEVICE",
    SUBMIT_INSTALL_DEVICE_FAILURE: "INSTALLATION__SUBMIT_INSTALL_DEVICE_FAILURE",

    ADDING_IMAGES_DEVICE_INSTALLATION_START: "INSTALLATION__ADDING_IMAGES_DEVICE_INSTALLATION_START",
    ADDING_IMAGES_DEVICE_INSTALLATION: "INSTALLATION__ADDING_IMAGES_DEVICE_INSTALLATION",
    ADDING_IMAGES_DEVICE_INSTALLATION_FAILURE: "INSTALLATION__ADDING_IMAGES_DEVICE_INSTALLATION_FAILURE",

    START_INSTALLATION_ORDER: "START_INSTALLATION_ORDER",
    SET_STATUS_TO_IN_PROGRESS: "SET_STATUS_TO_IN_PROGRESS",
    START_INSTALLATION_ORDER_FAILURE: "START_INSTALLATION_ORDER_FAILURE",

    ARCHIVE_INSTALLATION_ORDER_START: "INSTALLATION__ARCHIVE_INSTALLATION_ORDER_START",
    ARCHIVE_INSTALLATION_ORDER: "INSTALLATION__ARCHIVE_INSTALLATION_ORDER",
    ARCHIVE_INSTALLATION_ORDER_FAILURE: "INSTALLATION__ARCHIVE_INSTALLATION_ORDER_FAILURE",
  },

  SERVICE_ORDERS: {
    FETCH_SERVICE_ORDERS_LIST_START: "SERVICE_ORDERS__FETCH_SERVICE_ORDERS_LIST_START",
    FETCH_SERVICE_ORDERS_LIST: "SERVICE_ORDERS__FETCH_SERVICE_ORDERS_LIST",
    FETCH_SERVICE_ORDERS_LIST_FAILURE: "SERVICE_ORDERS__FETCH_SERVICE_ORDERS_LIST_FAILURE",

    FETCH_SERVICE_ORDER_DETAILS_START: "SERVICE_ORDERS__FETCH_SERVICE_ORDER_DETAILS_START",
    FETCH_SERVICE_ORDER_DETAILS: "SERVICE_ORDERS__FETCH_SERVICE_ORDER_DETAILS",
    FETCH_SERVICE_ORDER_DETAILS_FAILURE: "SERVICE_ORDERS__FETCH_SERVICE_ORDER_DETAILS_FAILURE",

    FETCH_SERVICE_ORDER_SOLUTIONS_LIST_START: "SERVICE_ORDERS__FETCH_SERVICE_ORDER_SOLUTIONS_LIST_START",
    FETCH_SERVICE_ORDER_SOLUTIONS_LIST: "SERVICE_ORDERS__FETCH_SERVICE_ORDER_SOLUTIONS_LIST",
    FETCH_SERVICE_ORDER_SOLUTIONS_LIST_LIST_FAILURE: "SERVICE_ORDERS__FETCH_SERVICE_ORDER_SOLUTIONS_LIST_LIST_FAILURE",

    ADD_NEW_SERVICE_ORDER_START: "SERVICE_ORDERS__ADD_NEW_SERVICE_ORDER_START",
    ADD_NEW_SERVICE_ORDER: "SERVICE_ORDERS__ADD_NEW_SERVICE_ORDER",
    ADD_NEW_SERVICE_ORDER_FAILURE: "SERVICE_ORDERS__ADD_NEW_SERVICE_ORDER_FAILURE",

    GET_ALL_SERVICE_ORDER_OWNER_START: "GET_ALL_SERVICE_ORDER_OWNER_START",
    GET_ALL_SERVICE_ORDER_OWNER: "GET_ALL_SERVICE_ORDER_OWNER",
    GET_ALL_SERVICE_ORDER_OWNER_FAILURE: "GET_ALL_SERVICE_ORDER_OWNER_FAILURE",
    GET_ALL_SERVICE_ORDER_OWNER_SUCCESS: "GET_ALL_SERVICE_ORDER_OWNER_SUCCESS",

    ADD_SERVICE_ORDER_ATTACHMENT_START: "SERVICE_ORDERS__ADD_SERVICE_ORDER_ATTACHMENT_START",
    ADD_SERVICE_ORDER_ATTACHMENT: "SERVICE_ORDERS__ADD_SERVICE_ORDER_ATTACHMENT",
    ADD_SERVICE_ORDER_ATTACHMENT_FAILURE: "SERVICE_ORDERS__ADD_SERVICE_ORDER_ATTACHMENT_FAILURE",

    FETCH_ALL_SEVICE_ORDER_ATTACHMENTS_START: "SERVICE_ORDERS__FETCH_ALL_SEVICE_ORDER_ATTACHMENTS_START",
    FETCH_ALL_SEVICE_ORDER_ATTACHMENTS: "SERVICE_ORDERS__FETCH_ALL_SEVICE_ORDER_ATTACHMENTS",
    FETCH_ALL_SEVICE_ORDER_ATTACHMENTS_FAILURE: "SERVICE_ORDERS__FETCH_ALL_SEVICE_ORDER_ATTACHMENTS_FAILURE",

    FETCH_SEVICE_ORDER_DETAILS_START: "SERVICE_ORDERS__FETCH_SEVICE_ORDER_DETAILS_START",
    FETCH_SEVICE_ORDER_DETAILS: "SERVICE_ORDERS__FETCH_SEVICE_ORDER_DETAILS",
    FETCH_SEVICE_ORDER_DETAILS_FAILURE: "SERVICE_ORDERS__FETCH_SEVICE_ORDER_DETAILS_FAILURE",

    GET_DEVICE_SERVICE_ORDER_ATTACHMENTS_LIST_START: "SERVICE_ORDERS__GET_DEVICE_SERVICE_ORDER_ATTACHMENTS_LIST_START",
    GET_DEVICE_SERVICE_ORDER_ATTACHMENTS_LIST: "SERVICE_ORDERS__GET_DEVICE_SERVICE_ORDER_ATTACHMENTS_LIST",
    GET_DEVICE_SERVICE_ORDER_ATTACHMENTS_LIST_FAILURE: "SERVICE_ORDERS__GET_DEVICE_SERVICE_ORDER_ATTACHMENTS_LIST_FAILURE",

    DELETE_DEVICE_SERVICE_ORDER_START: "SERVICE_ORDERS__DELETE_DEVICE_SERVICE_ORDER_START",
    DELETE_DEVICE_SERVICE_ORDER: "SERVICE_ORDERS__DELETE_DEVICE_SERVICE_ORDER",
    DELETE_DEVICE_SERVICE_ORDER_FAILURE: "SERVICE_ORDERS__DELETE_DEVICE_SERVICE_ORDER_FAILURE",

    SET_SERVICE_ORDER_ACTIVE_STEP: "SERVICE_ORDERS__SET_SERVICE_ORDER_ACTIVE_STEP",

    UPDATE_SERVICE_ORDER_BEFORE_IMAGE_ATTACHMENT_START: "SERVICE_ORDERS__UPDATE_SERVICE_ORDER_BEFORE_IMAGE_ATTACHMENT_START",
    UPDATE_SERVICE_ORDER_BEFORE_IMAGE_ATTACHMENT: "SERVICE_ORDERS__UPDATE_SERVICE_ORDER_BEFORE_IMAGE_ATTACHMENT",
    UPDATE_SERVICE_ORDER_BEFORE_IMAGE_ATTACHMENT_FAILURE: "SERVICE_ORDERS__UPDATE_SERVICE_ORDER_BEFORE_IMAGE_ATTACHMENT_FAILURE",
    DELETE_BEFORE_IMAGE: "DELETE_SERVICE_ORDER_BEFORE_IMAGE",

    UPDATE_SERVICE_ORDER_AFTER_IMAGE_ATTACHMENT_START: "SERVICE_ORDERS__UPDATE_SERVICE_ORDER_AFTER_IMAGE_ATTACHMENT_START",
    UPDATE_SERVICE_ORDER_AFTER_IMAGE_ATTACHMENT: "SERVICE_ORDERS__UPDATE_SERVICE_ORDER_AFTER_IMAGE_ATTACHMENT",
    UPDATE_SERVICE_ORDER_AFTER_IMAGE_ATTACHMENT_FAILURE: "SERVICE_ORDERS__UPDATE_SERVICE_ORDER_AFTER_IMAGE_ATTACHMENT_FAILURE",

    EDIT_SERVICE_ORDER_DATA_START: "SERVICE_ORDERS__EDIT_SERVICE_ORDER_DATA_START",
    EDIT_SERVICE_ORDER_DATA: "SERVICE_ORDERS__EDIT_SERVICE_ORDER_DATA",
    EDIT_SERVICE_ORDER_DATA_FAILURE: "SERVICE_ORDERS__EDIT_SERVICE_ORDER_DATA_FAILURE",

    REPACE_DEVICE_BY_IDS_START: "SERVICE_ORDERS__REPACE_DEVICE_BY_IDS_START",
    REPACE_DEVICE_BY_IDS: "SERVICE_ORDERS__REPACE_DEVICE_BY_IDS",
    REPACE_DEVICE_BY_IDS_FAILURE: "SERVICE_ORDERS__REPACE_DEVICE_BY_IDS_FAILURE",

    GET_SERVICE_CAUSES_START: "SERVICE_ORDERS__GET_SERVICE_CAUSES_START",
    GET_SERVICE_CAUSES: "SERVICE_ORDERS__GET_SERVICE_CAUSES",
    GET_SERVICE_CAUSES_FAILURE: "SERVICE_ORDERS__GET_SERVICE_CAUSES_FAILURE",

    SET_TARGET_REPLACEMENT_DEVICE: "SET_TARGET_REPLACEMENT_DEVICE",
  },

  MONITORING_MODULE: {
    GET_ORGANISATION_LIST: "GET_ORGANISATION_LIST",
    GET_DEVICENAME_LIST: "GET_DEVICENAME_LIST",
    GET_DEVICEMODEL_LIST: "GET_DEVICEMODEL_LIST",
    GET_PACKAGES: "GET_PACKAGES",
    GET_ERROR_CODES: "GET_ERROR_CODES",
    GET_STATUS_CODES: "GET_STATUS_CODES",
  },
};
